import { useQuery } from 'react-query'
import { api } from '../../../../services/api'
import { useState } from 'react'

export const useRelatorioDeTrocaService = () => {
  // Verificar se há filtros na URL ao inicializar
  const getInitialFilters = () => {
    const searchParams = new URLSearchParams(window.location.search)
    return {
      fornecedor: searchParams.get('fornecedor') || '',
      data_inicial: searchParams.get('data_inicial') || '',
      data_final: searchParams.get('data_final') || '',
    }
  }

  const [filtros, setFiltros] = useState(getInitialFilters())

  const fetchTrocas = async () => {
    let url = '/site/v2/controle-troca/busca-relatorio-trocas'
    const params = new URLSearchParams()

    if (filtros.fornecedor) {
      params.append('fornecedor', filtros.fornecedor)
    }

    if (filtros.data_inicial) {
      params.append('data_inicial', filtros.data_inicial)
    }

    if (filtros.data_final) {
      params.append('data_final', filtros.data_final)
    }

    const queryString = params.toString()
    if (queryString) {
      url += `?${queryString}`
    }

    try {
      const response = await api.get(url)
      return response.data
    } catch (error) {
      throw new Error('Erro ao buscar relatório de trocas')
    }
  }

  const { data, isLoading, error, refetch, isRefetching } = useQuery(['relatorio-trocas', filtros], fetchTrocas, {
    refetchOnWindowFocus: false,
    refetchInterval: 300000, // 5 minutos
  })

  const { data: fornecedores } = useQuery(
    'fornecedores',
    async () => {
      try {
        const response = await api.get('/site/v2/detalhes-produto/listar-fornecedores')
        return response.data
      } catch (error) {
        throw new Error('Erro ao buscar fornecedores')
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  // Função para aplicar filtros
  const aplicarFiltros = (novosFiltros) => {
    setFiltros(novosFiltros)
  }

  return {
    trocas: data || [],
    isLoading,
    error,
    isRefetching,
    refetch,
    filtros,
    aplicarFiltros,
    fornecedores,
  }
}
